/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getEmailList(state) {
		return state.EmailList;
	},
	getEmailTotal(state) {
		return state.EmailTotal;
	},
	getWidthSize(state) {
		return state.widthSize;
	},
	getSpamEmailList(state) {
		return state.SpamEmailList;
	},
	getSpamEmailTotal(state) {
		return state.SpamEmailTotal;
	},
	getTrashEmailList(state) {
		return state.TrashEmailList;
	},
	getTrashEmailTotal(state) {
		return state.TrashEmailTotal;
	},
	getTotalEmailUnRead(state) {
		return state.TotalEmailUnReadV2;
	},

	getEmailWaitingTotal(state) {
		return state.EmailWaitingTotal;
	},
	getEmailSpamWaitingTotal(state) {
		return state.EmailSpamWaitingTotal;
	},
	getHasAnyEmail(state) {
		return state.hasAnyEmail;
	}
};
